<nav
  class="navbar navbar-expand-lg navbar-primary"
  style="background: linear-gradient(to right, #250b4a 60%, #7340b2 100%)"
>
  <div class="container-fluid">
    <!-- Left Side: Image -->
    <div class="navbar-brand me-auto">
      <div class="oval-logo-wrapper" (click)="goToHome()">
        <div class="oval-ring"></div>
        <img
          src="assets/img/logo/edc_logo.png"
          alt="EDC Logo"
          class="oval-logo"
        />
      </div>

      <a class="d-flex align-items-center"> </a>
    </div>

    <div class="d-flex align-items-center">
      <ul class="navbar-nav flex-row ms-auto">
        <li class="nav-item dropdown">
          <a class="nav-link" [routerLink]="['/home']" role="button">
            <i class="bx bx-home bx-sm" style="color: white"></i>
          </a>
        </li>

        <li class="nav-item">
          <a class="nav-link" (click)="$event.preventDefault()">
            <i class="bx bx-help-circle bx-sm" style="color: white"></i>
          </a>
        </li>

        <li class="nav-item dropdown" [class.show]="showNotifications">
          <a
            class="nav-link position-relative dropdown-toggle"
            href="#"
            id="notificationDropdown"
            role="button"
            (click)="toggleNotifications(); $event.preventDefault()"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="bx bx-bell bx-sm" style="color: white"></i>
            <span
              class="badge rounded-pill bg-danger badge-notifications"
              *ngIf="unreadCount > 0"
            >
              {{ unreadCount > 99 ? '99+' : unreadCount }}
            </span>
          </a>
          <ul
            class="dropdown-menu dropdown-menu-end notification-dropdown"
            [class.show]="showNotifications"
            aria-labelledby="notificationDropdown"
            style="max-width: 350px; max-height: 400px; overflow-y: auto;"
          >
            <li>
              <h6 class="dropdown-header">
                <i class="bx bx-bell me-2"></i>Notifications
                <span class="badge bg-primary ms-2" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
              </h6>
            </li>
            <li><hr class="dropdown-divider" /></li>
            <li *ngIf="notifications.length === 0">
              <a class="dropdown-item text-center text-muted py-3">
                <i class="bx bx-bell-off d-block mb-2" style="font-size: 2rem;"></i>
                No notifications
              </a>
            </li>
            <li *ngFor="let notification of notifications; let i = index">
              <a
                class="dropdown-item notification-item position-relative"
                [class.unread]="notification.is_read === 0 || (!notification.isRead && notification.is_read !== 1)"
                (click)="$event.preventDefault()"
              >
                <!-- Close button (X) -->
                <button
                  type="button"
                  class="btn-close-notification"
                  (click)="markNotificationAsRead(notification, $event)"
                  aria-label="Mark as read"
                  title="Mark as read"
                >
                  <i class="bx bx-x"></i>
                </button>
                
                <div class="d-flex w-100">
                  <div class="flex-grow-1">
                    <h6 class="mb-1" style="font-size: 0.9rem; color: #250b4a; font-weight: 600;">
                      {{ getNotificationMessage(notification) }}
                    </h6>
                    <p class="mb-1 text-muted" style="font-size: 0.85rem; line-height: 1.4;">
                      {{ getNotificationFlow(notification) }}
                    </p>
                    <!-- <small class="text-muted" *ngIf="notification.query_text" style="font-size: 0.8rem;">
                      <i class="bx bx-message-square me-1"></i>
                      {{ notification.query_text }}
                    </small>
                    <small class="text-muted d-block mt-1" style="font-size: 0.75rem;" *ngIf="notification.created_by_name">
                      <i class="bx bx-user me-1"></i>
                      {{ notification.created_by_name }}
                      <span *ngIf="notification.created_by_designation"> ({{ notification.created_by_designation }})</span>
                    </small> -->
                  </div>
                  <div class="ms-2" *ngIf="notification.is_read === 0 || (!notification.isRead && notification.is_read !== 1)">
                    <span class="badge bg-primary rounded-circle" style="width: 8px; height: 8px; padding: 0;"></span>
                  </div>
                </div>
              </a>
              <hr class="dropdown-divider" *ngIf="i < notifications.length - 1" />
            </li>
            <li *ngIf="notifications.length > 0">
              <hr class="dropdown-divider" />
              <a class="dropdown-item text-center text-primary" (click)="closeNotifications(); $event.preventDefault()">
                Close
              </a>
            </li>
          </ul>
        </li>

        <li class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="userDropdown"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="bx bx-user bx-sm" style="color: white"></i>
          </a>
          <ul
            class="dropdown-menu dropdown-menu-end"
            aria-labelledby="userDropdown"
          >
            <li>
              <a
                class="dropdown-item"
                href="#"
                (click)="openProfile(); $event.preventDefault()"
              >
                <i class="bx bx-user-circle bx-sm me-2"></i> Profile
              </a>
            </li>
            <li><hr class="dropdown-divider" /></li>
            <li>
              <a class="dropdown-item text-danger" href="#" (click)="logout()">
                <i class="bx bx-power-off bx-sm me-2"></i> Logout
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>
<div
  class="profile-modal-backdrop"
  *ngIf="showProfileModal"
  (click)="closeProfile()"
></div>
<div
  class="profile-modal"
  *ngIf="showProfileModal"
  (click)="$event.stopPropagation()"
>
  <div class="profile-modal__header">
    <img
      src="assets/img/logo/TRA Logo.jpg"
      alt="The Red Arc"
      class="profile-modal__logo"
    />
    <h2>User Profile</h2>
  </div>
  <div class="profile-modal__details">
    <div class="profile-modal__row">
      <span class="label">First Name:</span>
      <span class="value">{{ userData?.firstName || 'N/A' }}</span>
    </div>
    <div class="profile-modal__row">
      <span class="label">Last Name:</span>
      <span class="value">{{ userData?.lastName || 'N/A' }}</span>
    </div>
    <div class="profile-modal__row">
      <span class="label">Email:</span>
      <span class="value">{{ userData?.email || 'N/A' }}</span>
    </div>
    <div class="profile-modal__row">
      <span class="label">Designation:</span>
      <span class="value">{{ userData?.designation || 'N/A' }}</span>
    </div>
  </div>
  <button
    class="btn btn-secondary profile-modal__close"
    (click)="closeProfile()"
  >
    Close
  </button>
</div>
